<template>
  <div class="container">
    <div class="row">
        <div class="page-body">
            <div class="info-page-body support-page-body">
                <div class="support-title">
                    <h1 class="page-title">{{ $t('getHelpWithYourHotelBooking') }}</h1>
                    <router-link :to="{ name: 'SupportPage' }" class="btn-text">
                      <i class="fal fa-angle-left"></i>
                      {{ $t('backToSupportHome') }}
                    </router-link>
                </div>

                <div class="content-panel tabs-title">
                    <div class="panel-tabs">
                    <ul>
                        <li v-for="(tab, index) in tabs" :key="index" :class="[{ active: currentTab === tab.ref }]">
                          <a @click="currentTab = tab.ref" :title="tab.name">{{ tab.name }}</a>
                        </li>
                    </ul>
                    </div>
                    <div class="panel-body p-margin">
                      <div class="support-tabgroup" v-if="currentTab === 'bookingLookup'">

                          <form>
                            <div class="form-group">
                                <label for="">
                                  {{ $t('bookingReference') }}: *
                                  <i class="fal fa-info-circle" 
                                      v-tooltip="$t('bookingReferenceParagraph')">
                                  </i>
                                </label>
                                <input type="text" v-model="bookingLookup.orderReference" v-validate="'required'" :name="$t('bookingReference')" />
                                <span v-if="showFieldErrors" class="invalid">{{ errors.first('bookingLookupForm.' + $t('bookingReference')) }}</span>
                            </div>

                            <div class="form-group">
                                <label for="fieldBookingEmailAddress">{{ $t('primaryEmailAddressUsedWhenBooking') }}: *</label>
                                <input type="email" v-model="bookingLookup.email" v-validate="'required|email'" id="fieldBookingEmailAddress" :name="$t('emailAddress')" />
                                <span v-if="showFieldErrors" class="invalid">{{ errors.first('bookingLookupForm.' + $t('emailAddress')) }}</span>
                            </div>

                            <button type="submit" @click="lookupBooking()" class="btn btn-lg btn-primary">{{ $t('viewMyBooking') }}</button>
                          </form>
                      </div>
              
                      <div class="support-tabgroup" v-if="currentTab === 'supportRequests'">
                        <p>{{ $t('hotelSupportByPhoneParagraph1') }} <strong>877-477-7441</strong></p>
                        
                        <p>{{ $t('hotelSupportByPhoneParagraph2') }}</p>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

export default {
  name: 'HotelsSupport',
  data () {
    let self = this;
    return {
      title: 'Hotel Support',
      showFormError: false,
      showFieldErrors: false,
      bookingLookup: {
        orderReference: '',
        email: ''
      },
      currentTab: 'bookingLookup',
      tabs: [ 
        {
          ref: 'bookingLookup',
          name: self.$t('viewUpdateMyBooking')
        },
        {
          ref: 'supportRequests',
          name: self.$t('supportByPhone')
        }
      ]
    }
  },

  metaInfo() {
    let self = this;
    return {
      title: self.$t('customerSupport') + ' - ' + self.$t('getHelpWithYourHotelBooking')
    }
  },

  methods: {
    lookupBooking(scope) {
        let self = this;
        let orderReference = self.bookingLookup.orderReference;
        let email = self.bookingLookup.email;

        self.$validator.validateAll().then((result) => {
            if (result) {
            self.$router.push({
                name: 'EditHotelBooking', 
                params: { 
                  bookingId: orderReference,
                  email: email
                }
            });
            } 
            if(!result) {
                self.showFieldErrors = true;
            }
        })
        
        
        }
  },
  computed: {
  }
}
</script>
